// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__19lN7","head":"ProcedureTableInfo_head__2lTSX"};